export default "__VITE_ASSET__O5TS4j8d__"